export default __webpack_public_path__ + "static/media/mode_cool.92289492.svg";